import { DELIVERY_NOTE_VALIDATION_RESULT_STATUS } from './constants';
import { type DeliveryNoteValidationResult } from './types';

export const DeliveryNoteValidationResultObject = {
  STATUS: DELIVERY_NOTE_VALIDATION_RESULT_STATUS,

  /**
   * Creates a DeliveryNoteValidationResult object with the given validation result.
   * @param {object} validationResult - The validation result object.
   * @returns {object} - The created DeliveryNoteValidationResult object.
   */
  create(validationResult: Partial<DeliveryNoteValidationResult> = {}) {
    return {
      status: validationResult?.cat,
      message: validationResult?.msg,
      backendPath: validationResult?.loc,
    };
  },
};
